var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.32 2.05006L13.32 0.0500547H13.25C13.2035 0.0453763 13.1566 0.0453763 13.11 0.0500547H12.88H12.75H12.68L7 2.00005L1.32 0.0500547C1.16962 0.000466276 1.00961 -0.0126999 0.853139 0.0116395C0.696671 0.035979 0.548219 0.0971284 0.420003 0.190055C0.290762 0.282071 0.185268 0.403518 0.112238 0.544362C0.039208 0.685206 0.000736954 0.841405 3.33354e-06 1.00005V15.0001C-0.000537828 15.2097 0.0648223 15.4142 0.186845 15.5847C0.308868 15.7552 0.481382 15.883 0.680003 15.9501L6.68 17.9501C6.88145 18.0157 7.09856 18.0157 7.3 17.9501L13 16.0501L18.68 18.0001C18.7862 18.0145 18.8938 18.0145 19 18.0001C19.2091 18.003 19.4132 17.9361 19.58 17.8101C19.7092 17.718 19.8147 17.5966 19.8878 17.4557C19.9608 17.3149 19.9993 17.1587 20 17.0001V3.00005C20.0005 2.79041 19.9352 2.5859 19.8132 2.41543C19.6911 2.24495 19.5186 2.11714 19.32 2.05006ZM6 15.6101L2 14.2801V2.39005L6 3.72005V15.6101ZM12 14.2801L8 15.6101V3.72005L12 2.39005V14.2801ZM18 15.6101L14 14.2801V2.39005L18 3.72005V15.6101Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.bdf5cb56710316ca6c239f2823d27522.svg";
export { ForwardRef as ReactComponent };